import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';

const entityKey = 'changePassword';

const stateReducer = combineReducers({
    records: recordsReducer,
});

export default stateReducer;
